module.exports = __webpack_public_path__ + "img/accessory_pants_06.aeb5b171.svg";